import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { UPDATE_SUBSCRIPTION_REQUEST, UPDATE_SUBSCRIPTION_SUCCESS, UPDATE_SUBSCRIPTION_ERROR } from '../types';
import { useHelper } from '../helpers';
export var updateSubscriptionRequest = function updateSubscriptionRequest(id) {
  return {
    type: UPDATE_SUBSCRIPTION_REQUEST,
    payload: id
  };
};
export var updateSubscriptionSuccess = function updateSubscriptionSuccess(_ref) {
  var data = _ref.data;
  return {
    type: UPDATE_SUBSCRIPTION_SUCCESS,
    payload: {
      data: data
    }
  };
};
export var updateSubscriptionError = function updateSubscriptionError(id, error) {
  return {
    type: UPDATE_SUBSCRIPTION_ERROR,
    payload: {
      error: error,
      id: id
    },
    error: true
  };
};
export var updateSubscription = function updateSubscription(subscriptionId) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref2) {
        var chord, _useHelper, withAuth, input, _getState, user, userId, skus, _response, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              chord = _ref2.chord;
              _useHelper = useHelper(dispatch, getState), withAuth = _useHelper.withAuth;
              input = props;
              dispatch(updateSubscriptionRequest(subscriptionId));
              _context.prev = 4;
              _getState = getState(), user = _getState.user;
              userId = user.data.id;
              if (!props.lineItemsAttributes) {
                _context.next = 13;
                break;
              }
              skus = props.lineItemsAttributes.map(function (li) {
                return li.sku;
              });
              _context.next = 11;
              return withAuth(chord.oms.getVariantsBySkus)(skus);
            case 11:
              _response = _context.sent;
              input.lineItemsAttributes = input.lineItemsAttributes.map(function (attr) {
                var _response$variants, _response$variants$fi;
                var subscribableId = _response === null || _response === void 0 ? void 0 : (_response$variants = _response.variants) === null || _response$variants === void 0 ? void 0 : (_response$variants$fi = _response$variants.find(function (v) {
                  return v.sku === attr.sku;
                })) === null || _response$variants$fi === void 0 ? void 0 : _response$variants$fi.id;
                return _objectSpread(_objectSpread({}, attr), {}, {
                  subscribableId: subscribableId
                });
              });
            case 13:
              _context.next = 15;
              return withAuth(chord.oms.updateSubscription)(userId, subscriptionId, input);
            case 15:
              response = _context.sent;
              dispatch(updateSubscriptionSuccess({
                data: response
              }));
              return _context.abrupt("return", response);
            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](4);
              dispatch(updateSubscriptionError(subscriptionId, _context.t0));
              throw _context.t0;
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4, 20]]);
      }));
      return function (_x, _x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }();
  };
};